import { render, staticRenderFns } from "./BaseNotificationItemContentsParts.vue?vue&type=template&id=2af58076&scoped=true"
import script from "./BaseNotificationItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./BaseNotificationItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./BaseNotificationItemContentsParts.vue?vue&type=style&index=0&id=2af58076&prod&lang=scss&scoped=true"
import style1 from "./BaseNotificationItemContentsParts.vue?vue&type=style&index=1&id=2af58076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af58076",
  null
  
)

export default component.exports